var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.90723 12.9075L10.7706 4.04417C11.143 3.67184 11.7468 3.67184 12.1192 4.04417L20.9826 12.9075H19.075V20.5377C19.075 21.0644 18.648 21.4914 18.1213 21.4914H13.3524V14.8151H9.53737V21.4914H4.76853C4.24178 21.4914 3.81476 21.0644 3.81476 20.5377V12.9075H1.90723Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.bc0e5643f8880ca90b4848731bded95d.svg";
export { ForwardRef as ReactComponent };